<template>
	<Card
		:class="
			cn(
				propertyCardBodyVariants({ size, variant }),
				propertyCardSkeletonVariants({ variant })
			)
		"
	>
		<Skeleton
			:is-active="true"
			:variant="skeletonVariant"
			:class="propertyCardHeaderBodyVariants({ variant, size })"
		/>
		<div
			:class="
				cn(propertyCardFooterBodyVariants({ variant, size }), '!border-none')
			"
			class="flex flex-col gap-2"
		>
			<div>
				<Skeleton
					:is-active="true"
					:variant="skeletonVariant"
					class="h-[18px] w-[30%]"
				/>
			</div>

			<div class="flex items-center gap-2">
				<Skeleton
					:is-active="true"
					:variant="skeletonVariant"
					class="h-[18px] w-[30%]"
				/>
				<Skeleton :is-active="true" :variant="skeletonVariant" class="size-1" />
				<Skeleton
					:is-active="true"
					:variant="skeletonVariant"
					class="h-[18px] w-[30%]"
				/>
				<Skeleton :is-active="true" :variant="skeletonVariant" class="size-1" />

				<Skeleton
					:is-active="true"
					:variant="skeletonVariant"
					class="h-[18px] w-[30%]"
				/>
			</div>
			<div class="flex items-center gap-2">
				<Skeleton
					:is-active="true"
					:variant="skeletonVariant"
					class="h-[18px] w-[85%]"
				/>
			</div>
		</div>
	</Card>
</template>
<script lang="ts" setup>
import type { PropertyCardSkeletonProps } from '.';

import { cn } from '@/utils';
import { computed } from 'vue';

import { Skeleton } from '../ui/skeleton';
import {
	propertyCardBodyVariants,
	propertyCardFooterBodyVariants,
	propertyCardHeaderBodyVariants,
	propertyCardSkeletonVariants
} from './index';

const props = defineProps<PropertyCardSkeletonProps>();

const skeletonVariant = computed(() =>
	props.variant === 'whiteBackground' ? 'white' : 'primary'
);
</script>
